<template>
    <ul id="rechargeRecord">
        <mt-loadmore :bottom-method="getAgentPrechargeListHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <li  v-for="item in prechargeRecord" :key="item.id" class="oneRecord">
                <ul>
                    <li>
                        <label>支付状态</label>
                        <span>{{item.payStateName}}</span>
                    </li>
                    <li>
                        <label>充值金额</label>
                        <span>{{item.priceRmb}} 元</span>
                    </li>
                    <!-- <li>
                        <label>账户总额</label>
                        <span>{{item.payStateName}}</span>
                    </li> -->
                    <li>
                        <label>支付时间</label>
                        <span>{{item.createTime}}</span>
                    </li>
                    <li>
                        <label>订单号</label>
                        <span>{{item.orderNo}}</span>
                    </li>
                </ul>
            </li>
        </mt-loadmore>
    </ul>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            prechargeRecord: [],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            allLoaded: false            
        }
    },
    methods: {
        getAgentPrechargeListHandler(){
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                perPageNum: this.perPageNum
            }
            wxRequest('order/investOrder/app/listPage', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }

                    this.prechargeRecord = this.prechargeRecord.concat(res.data.data.resultList)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                    
                }
            })
        }
    },
    created(){
        this.getAgentPrechargeListHandler();
    }
}
</script>
<style lang="less" scoped>
#rechargeRecord {
    min-height: 100%;
    background: #f2f2f2;
    padding: 10px 3%;
    box-sizing: border-box;
    li.oneRecord {
        background: #fff;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 10px;
        ul li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eaeaea;
            display: flex;
            justify-content: space-between;
            &:last-child {
                border-bottom: none;
            }
            span {
                color: #26a2ff;
            }
        }
    }
}
</style>
